module.exports = __webpack_public_path__ + "img/bird-inventory.13f75c32.svg";